var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.activeLoading}},[_c('span',[_vm._v(_vm._s(_vm.loadingPageMsg))]),_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('v-content',[(
        _vm.$route.name === 'landingPage' ||
          _vm.$route.name === 'faq' ||
          _vm.$route.name == 'login' ||
          _vm.$route.name == 'register' ||
          _vm.$route.name == 'ADP' ||
          _vm.$route.name == 'ResetPassEmail' ||
          _vm.$route.name == 'ResetChangeEmail' ||
          _vm.$route.name == 'ResetPass' ||
          _vm.$route.name == 'ResetEmail' ||
          _vm.$route.name == 'veterinarias'
      )?_c('div',[_c('Nav')],1):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }